import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';


import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


class ScrollReveal {
  constructor(options){
    this.options = options;
  }

  reveal(el, options, duration){
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire( el, function(){
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options,args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');

      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');
      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1000,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-ordermade-slider').find('.c-block-order__image').length < 2){
          $('.js-ordermade-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-ordermade-slider').owlCarousel({
          margin: 30,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 2000,
          autoWidth: true,
          autoHeight: false,
          center: false,
          animateOut: 'fadeOut',
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              center : true,
            },
            // breakpoint from 750 up
            750: {
            }
          }
        });
      });

      owls.imagesLoaded(function () {

        if (window.innerWidth > 750) {
          $('.c-card-news__list').toggleClass('owl-carousel');
          return false;
        }
        if ($('.c-card-news__list').find('.c-card-news__items').length < 2){
          $('.c-card-news__list').toggleClass('owl-carousel');
          return false;
        }
        $('.c-card-news__list').owlCarousel({
          margin: 25,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 2000,
          autoWidth: true,
          autoHeight: false,
          center: false,
          animateOut: 'fadeOut',
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 3,
              center : true,
            },
            // breakpoint from 750 up
            750: {
            }
          }
        });
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        let $item = 6;
        let $marginSize = 30;
        let $dots = false;
        let $navs = true;
        let $autowidth = true;
        let $navsText =  ['<img src="/wp-content/themes/maile-html/dist/assets/images/icon-gallery-prev.png">','<img src="/wp-content/themes/maile-html/dist/assets/images/icon-gallery-next.png">'];
        if ($('.js-card-case-slider').find('.c-card-case__item').length < 5){
          $('.js-card-case-slider').toggleClass('owl-carousel');
          return false;
        }
        if ($('.js-card-case-slider').hasClass('is-details')){
          console.log("true");
          $item = 4;
          $marginSize = 0;
          $dots = false;
          $navs = true;
          $autowidth = true;
          $navsText = ['<img src="/wp-content/themes/maile-html/dist/assets/images/icon-gallery-prev.png">','<img src="/wp-content/themes/maile-html/dist/assets/images/icon-gallery-next.png">'];
        }
        $('.js-card-case-slider').owlCarousel({
          item: $item,
          margin: $marginSize,
          dots: $dots,
          loop: true,
          nav: $navs,
          navText: $navsText,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1000,
          autoWidth: $autowidth,
          autoHeight: false,
          center: false,
          responsive: {
            // breakpoint from 0 up
            0: {
              center : true,
              margin: 0,
            },
            // breakpoint from 750 up
            750: {
            }
          }
        });
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        const $galleryImages = $('.js-hero-block-gallery-images');
        $.each($galleryImages, function(index, element) {
          // if ($(element).find('.c-hero-block-gallery__image').length < 2){
          //   $(element).toggleClass('owl-carousel');
          //   return false;
          // }
          $(element).owlCarousel({
            margin: 120,
            item:1,
            dots: true,
            loop: true,
            nav: false,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 2000,
            autoWidth: true,
            autoHeight: false,
            center: true,
            animateOut: 'fadeOut',
            stagePadding:0,
            responsive: {
              // breakpoint from 0 up
              0: {
                center : true,
                margin : 40,
                nav: true,
              },
              // breakpoint from 750 up
              750: {
              }
            }
          });
        } );
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-hero-block-gallery-list').find('.c-hero-block-gallery__item').length < 2){
          $('.js-hero-block-gallery-list').toggleClass('owl-carousel');
          return false;
        }
        $('.js-hero-block-gallery-list').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          item: 1,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 1000,
          autoWidth: true,
          autoHeight: false,
          animateOut: 'fadeOut',
          center: true,
          stagePadding: 50,
          responsive: {
            // breakpoint from 0 up
            0: {
              center : true,
              margin: 0
            },
            // breakpoint from 750 up
            750: {
            }
          }
        });
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        const $galleryImages = $('.js-quality-slider');
        $.each($galleryImages, function(index, element) {
          if ($(element).find('.c-block-category__block-image').length === 1){
            $(element).toggleClass('owl-carousel');
            return false;
          }
          $(element).owlCarousel({
            margin: 0,
            item:1,
            dots: true,
            loop: true,
            nav: false,
            autoplayHoverPause: true,
            autoplay: true,
            autoplaySpeed: 2000,
            autoWidth: true,
            autoHeight: false,
            center: true,
            animateOut: 'fadeOut',
            stagePadding:0,
            responsive: {
              // breakpoint from 0 up
              0: {
                center: true
              },
              // breakpoint from 750 up
              750: {
              }
            }
          });
        } );
      });
    }
    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '8';

      sr.reveal(".c-", {
        duration: 1400,
        opacity: 1,
        //translateY: -baseDistance,
        delay: 900,
      }, 100);

      sr.reveal(".c-hero-block-number__image",{
        opacity: 1,
        duration: 600,
        delay: anime.stagger(100),
        translateY: [baseDistance,0],
        easing: baseEasing
      });
      domEach(".c-box-banners__items-title", function(key, item){

        sr.reveal(item,{
          scale: {
            value: [0.9,1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100*key,
          translateY: [-baseDistance,0],
          easing: baseEasing
        } );
      });
    }



    // slick
    function slickSlider() {

      if ($('.c-gallery-slider__main').children().length <= 0 ){
        return false;
      }

      if ($('.c-gallery-slider__thumbnail').children().length < 7 && window.innerWidth > 750) {
        $(".c-gallery-slider__thumbnail").addClass("is-simple-center");
      }

      if ($('.c-gallery-slider__thumbnail').children().length <= 4 && window.innerWidth <= 750) {
        $(".c-gallery-slider__thumbnail").addClass("is-transition-none");
      }

      if ($('.c-gallery-slider__thumbnail').children().length < 2) {
        $(".c-gallery-slider__thumbnail").addClass("is-simple-none");
      }

      // 上段
      $('.c-gallery-slider__main').slick({
        infinite: true,
        arrow: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><img src="/wp-content/themes/maile-html/dist/assets/images/icon-gallery-next.png"></div>',
        nextArrow: '<div class="slick-next"><img src="/wp-content/themes/maile-html/dist/assets/images/icon-gallery-prev.png"></div>',
        asNavFor: '.c-gallery-slider__thumbnail',
        autoplaySpeed: 2500,
        // centerPadding: '23.28%',
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1
          }
        }]
      });

      // 下段
      $('.c-gallery-slider__thumbnail').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        asNavFor: '.c-gallery-slider__main',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 4
          }
        }]
      });
    }

    function loopSlider() {

      const slider = $(".c-block-insta-gallery__images");
      if (!slider) return;
      slider.slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 30000, //スライドが流れる速度を設定
        cssEase: "linear", //スライドの流れ方を等速に設定
        slidesToShow: 1, //表示するスライドの数
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示
        pauseOnFocus: false, //スライダーをフォーカスした時にスライドを停止させるか
        pauseOnHover: false, //スライダーにマウスホバーした時にスライドを停止させるか
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 1, //画面幅750px以下でスライド3枚表示
            }
          }
        ]
      });
    }

    function infiniteSlider() {

      const slider = $(".c-block-infinite-slider__slide");

      if (!slider) return false;

      $(slider).slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 20000, //スライドが流れる速度を設定
        cssEase: "linear", //スライドの流れ方を等速に設定
        slidesToShow: 1, //表示するスライドの数
        centerMode: true,
        variableWidth: true,
        infinite: true,
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示

        responsive: [
          {
            breakpoint: 750,
            settings: {
              // slidesToShow: 1, //画面幅750px以下でスライド3枚表示
            }
          }
        ]
      });
    }


    function shopImageSlider() {
      if (window.innerWidth <= 950 ) {
        let $image = $('.c-block-shop__image');
        let imageIndex = -1;
        function changeImage() {
          var $slider = $('.js-view-gallery');
          if ($slider.length === 0) {
            return false;
          }

          imageIndex++;

          var currentNum = imageIndex % $image.length;
          var nextNum = (imageIndex + 1) % $image.length;
          var current = $image.eq(currentNum);
          var next = $image.eq(nextNum);

          current.removeClass('is-active');
          next.addClass('is-active');

        }

        setInterval(changeImage, 5000);
      }
    }



    $(function () {
      menuSlide();
      owlCarousel();
      reveal();
      slickSlider();
      loopSlider();
      infiniteSlider();
      shopImageSlider();
    });
  }
}

window.GApp = new App();
